import React, { useEffect, useState } from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MerchantLayout from '../../../layout/MerchantLayout';
import { Grid, Paper } from '@material-ui/core';
import { getTotalBalance, startPayment } from '../../../services/c2dcrm';
import { useAuth } from '../../../hooks/useAuth';
import CheckoutForm from './CheckoutForm';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  banner: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    margin: '16px',
  },
  emailWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '40px',
  },
  paper: {
    padding: '10px',
    textAlign: 'center',
    maxWidth: '900px'
  },
  container: {
    maxWidth: '900px'
  },
}));

const TEST_TOKEN = 'pk_test_51JucsMDCzQbq7LtquErHk2e9wppoS9d5mXB32nCeExLQ6aThY6zaqBvq8kfJNAglVUg8s5NVRY7a1W8X8ZcWr7n6004Xjqwr3j';
const stripePromise = loadStripe(TEST_TOKEN);

const MerchantPayments: React.FC = () => {
  const { token } = useAuth();
  const [balance, setBalance] = useState(0.0);
  const [clientSecret, setClientSecret] = useState('');
  const [paymentClientSecret, setPaymentClientSecret] = useState('');
  const [topupAmount, setTopupAmount] = useState(0);
  const classes = useStyles();

  useEffect(() => {
    getTotalBalance(token).then((response) => {
      if (response) setBalance(response.data.amount);
    });
  }, [topupAmount, token]);

  useEffect(() => {
    if (topupAmount > 0) {
      startPayment(token, topupAmount).then((response) => {
        if (response.status === 200) {
          setClientSecret(response.data.value);
        }
      });
    }
  }, [topupAmount, token]);

  useEffect(() => {
    const paymentClientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );
    if (paymentClientSecret) {
      setClientSecret(paymentClientSecret);
      setPaymentClientSecret(paymentClientSecret);
    }
  }, [])

  const add50 = () => {
    setTopupAmount(5000);
  }

  const add100 = () => {
    setTopupAmount(10000);
  }

  const add250 = () => {
    setTopupAmount(25000);
  }

  const options = {
    clientSecret
  };

  return (
    <MerchantLayout>
      <Paper>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          spacing={4}
        >
          <Grid item xs={12} className={classes.paper}>
            <h1>Payments</h1>
          </Grid>
          <Grid item xs={12} className={classes.paper}>
            <Typography className="h2" component="div">
              Current Balance:
            </Typography>
            <Typography className="h2" component="div">
              RM{balance / 100}
            </Typography>
          </Grid>
        </Grid>
        {!paymentClientSecret && topupAmount === 0 && (
          <Grid item xs={12}>
            <Grid
              container
              spacing={4}
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={12} className={classes.paper}>
                Please choose a Top Up amount:
              </Grid>
              <Grid item xs={12} sm={4} className={classes.paper}>
                <button type="button" onClick={add50}> RM50.00</button>
              </Grid>
              <Grid item xs={12} sm={4} className={classes.paper}>
                <button type="button" onClick={add100}> RM100.00</button>
              </Grid>
              <Grid item xs={12} sm={4} className={classes.paper}>
                <button type="button" onClick={add250}> RM250.00</button>
              </Grid>
            </Grid>
          </Grid>
        )}
        {clientSecret && (<Grid item xs={12}>
          <Elements options={options} stripe={stripePromise}>
            <CheckoutForm topupAmount={topupAmount} />
          </Elements>
        </Grid>)}
      </Paper>
    </MerchantLayout >
  );
};

export default MerchantPayments;
